<template>
    <div class="signin__topNavBar">
        <span class="mdi mdi-window-minimize"></span>
        <span class="mdi mdi-window-maximize pl-3"></span>
        <span class="mdi mdi-window-close pl-3"></span>
    </div>
</template>